import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";
import { MaterialPojectType } from "../../Controllers/Types/HeyTraderTypes/Materials/MaterialPojectType";
import { TemplateType } from "../../Controllers/Types/HeyTraderTypes/Materials/TemplateType";
import { ShareContactType } from "../../Controllers/Types/Share/ShareContactType";


// models from types
export const getAllMaterialProjectListService = async () => {
  try {
    const response = await apiClient.get(`/api/material-project-data-new`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//create function for projects add
export const addProjectForMaterial = async (
  listx: MaterialPojectType[]
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list

    const list = listx.map((e) => e.project_id);

    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/material-project-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ list }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// get all category list
export const getAllMaterialCategoryListService = async () => {
  try {
    const response = await apiClient.get(`/api/material-category-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create category names
export const addMaterialCategory = async (
  category_name: string,
  fors: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-category-create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ category_name: category_name, for: fors }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update 
export const updateMaterialCategory = async (
  category_name: string,
  fors: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-category-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ category_name: category_name, for: fors }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// delete
export const deleteMaterialCategory = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/user-material-category-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};


// create sub category names
export const addMaterialSubCategory = async (
  category_id: number,
  sub_category_name: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-sub-category-create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ category_id, sub_category_name }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update
export const updateMaterialSubCategory = async (
  category_id: number,
  sub_category_name: string,
  id: number,
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-sub-category-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ category_id, sub_category_name }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// delete
export const deleteMaterialSubCategory = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/user-material-sub-category-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create material names
export const addMaterial = async (
  project_id: number,
  category_id: number,
  sub_category_id: number,
  length: number,
  width: number,
  hight: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-data-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        project_id,
        category_id,
        sub_category_id,
        length,
        width,
        hight,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update material names
export const updateMaterial = async (
  project_id: number,
  category_id: number,
  sub_category_id: number,
  length: number,
  width: number,
  hight: number,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-data-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          project_id,
          category_id,
          sub_category_id,
          length,
          width,
          hight,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deleteMaterialData = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/user-material-data-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// get material units
export const getAllMaterialUnitListService = async () => {
  try {
    const response = await apiClient.get(`/api/material-data-unit`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create material names
export const addMaterialItem = async (
  material_data_id: number,
  unit_id: number,
  item_name: string,
  quantity: number,
  unit_price: number,
  sub_total: number,
  include_tax: number,
  note: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-item-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        material_data_id,
        unit_id,
        item_name,
        quantity,
        unit_price,
        sub_total,
        include_tax,
        note,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
// update material names
export const updateMaterialItem = async (
  material_data_id: number,
  unit_id: number,
  item_name: string,
  quantity: number,
  unit_price: number,
  sub_total: number,
  include_tax: number,
  note: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-item-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          material_data_id,
          unit_id,
          item_name,
          quantity,
          unit_price,
          sub_total,
          include_tax,
          note,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deleteMaterialItemData = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/user-material-item-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create order
export const addOrder = async (
  estimation_id: number,
  quantity: number,
  unit_price: number,
  date: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-order-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ estimation_id, quantity, unit_price, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// updat order
export const updateOrder = async (
  quantity: number,
  unit_price: number,
  date: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-order-update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ quantity, unit_price, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete Order
export const deleteOrder = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/user-material-order-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// working with deleverd

// create Deleverd
export const addDeleverd = async (
  estimation_id: number,
  delivered_quantity: number,
  date: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-delivered-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ estimation_id, delivered_quantity, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
// updat Deleverd
export const updateDeleverd = async (
  delivered_quantity: number,
  date: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-delivered-update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ delivered_quantity, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete Deleverd
export const deleteDeleverd = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-delivered-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// working with onsite
// create Onsite
export const addOnsite = async (
  estimation_id: number,
  onsite_quantity: number,
  date: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-onsite-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ estimation_id, onsite_quantity, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// updat Onsite
export const updateOnsite = async (
  onsite_quantity: number,
  date: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/user-material-onsite-update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ onsite_quantity, date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete Onsite
export const deleteOnsite = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/user-material-onsite-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};


// get material units
export const getAllMaterialTemplateListService = async () => {
  try {
    const response = await apiClient.get(`/api/material-template-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create order need to rebuild.
export const createMaterialTemplate = async (
  template_id: number,
  project_id: number,
  list: TemplateType[],
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/material-template-used`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ template_id, project_id, list }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// material share function
export const shareMaterials = async (
  share: ShareContactType[],
  project_id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/material-project-share`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ project_id, share }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
